<template>
  <div>
    <h3>Deletable Project</h3>
    <div class="container">
        <form @submit.prevent="loadData" class="form-horizontal">
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchDbNumber">DB Number</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchDbNumber" v-model="projectSearchDto.dbNumber">
                </div>
                <div class="col-sm-2 col-sm-offset-1">
                    <label for="searchName">Project Name</label>
                </div>
                <div class="col-sm-5">
                    <input class="form-control" type="text" name="searchName" v-model="projectSearchDto.name">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchAgencyNumber">Agency Number</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchAgencyNumber" v-model="projectSearchDto.agencyNumber">
                </div>
                <div class="col-sm-2 col-sm-offset-1">
                    <label for="searchAgencyName">Agency Name</label>
                </div>
                <div class="col-sm-5">
                    <input class="form-control" type="text" name="searchAgencyName" v-model="projectSearchDto.agencyName">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchfieldOrgNumber">Field Org. Number</label>
                </div>
                <div class="col-sm-2">
                    <input class="form-control" type="text" name="searchfieldOrgNumber" v-model="projectSearchDto.fieldOrgNumber">
                </div>
                <div class="col-sm-2 col-sm-offset-1">
                    <label for="searchFieldOrgName">Field Org. Name</label>
                </div>
                <div class="col-sm-5">
                    <input class="form-control" type="text" name="searchFieldOrgName" v-model="projectSearchDto.fieldOrgName">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchProjectType">Project Type</label>
                </div>
                <div class="col-sm-3">
                    <input class="form-control" type="text" name="searchProjectType" v-model="projectSearchDto.projectType">
                </div>
                <div class="col-sm-2">
                    <label for="searchFieldOrgName">Created Date Range</label>
                </div>
                <div class="col-sm-2">
                    <el-date-picker v-model="projectSearchDto.startDate" type="date" format="MM/dd/yyyy" placeholder="From Date"></el-date-picker>
                </div>
                <div class="col-sm-2">
                    <el-date-picker v-model="projectSearchDto.endDate" type="date" format="MM/dd/yyyy" placeholder="To Date"></el-date-picker>
                </div>
            </div>
            <div class="form-group form-check">
                <div class="col-sm-2">
                    <label class="form-check-label" for="showInactive">Show Inactives</label>
                </div>
                <div class="col-sm-4">
                    <input class="form-check-input" type="checkbox" v-model="projectSearchDto.showInactive" style="width: 20px; height: 20px;">
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-2">
                    <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
                </div>
            </div>
        </form>
    </div>
    <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
          <loader v-if="loading"/>
          <div>
            <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options">
              <template slot="delete" slot-scope="props">
                <div style="text-align: center;">
                    <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteRow(props.row)"></a>
                </div>
              </template>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import projectService from '../services/projectService'

import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            list: null,
            projectSearchDto: {
                showInactive: false,
                name: '',
                dbNumber: '',
                agencyNumber: '',
                agencyName: '',
                fieldOrgNumber: '',
                fieldOrgName: '',
                projectType: '',
                startDate: null,
                endDate: null
            },
            gridSpec: {
                columns: ['delete', 'name', 'dbNumber', 'projectTypeCode', 'projectTypeDescription', 'agencyDescription', 'clientDescription', 'fieldOrgDescription', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        dbNumber: 'DB Number',
                        projectTypeCode: 'Code',
                        projectTypeDescription: 'Type',
                        agencyDescription: 'Agency',
                        clientDescription: 'Client',
                        fieldOrgDescription: 'Field Org.',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Projects', 'mounted')

        //this.loadData()
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'Projects', 'loadData')
            this.loading = true
            this.gridSpec.tableData = []
            var handle = this
            handle.list = null
            return projectService.searchDeletableProjects(this.$http, this.projectSearchDto).then(function (response) {
                loggingService.log(handle.isDebug, 'Projects', 'projectService.search.then')

                handle.gridSpec.tableData = response.data
                handle.loading = false
            })
        },
        deleteRow (project) {
            loggingService.log(this.isDebug, 'Projects', 'delete, id: ' + project.projectId)
            if (confirm(`Are you sure you wish to delete Project ${project.dbNumber}?  NOTE: This action is irreversible.`)) {
                return projectService.remove(this.$http, project.projectId).then(result => {
                    if (result.data.messages && result.data.messages.count > 0) {
                        alert(result.data.messages.join('\n'))
                    }
                    this.gridSpec.tableData = this.gridSpec.tableData.filter(x => x.projectId !== project.projectId)
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ProjectsDelete.vue?59b44cef